export default __webpack_public_path__ + "b8b628e80d77f245415ae15630bce614.png";